// @flow
import { GET_CONTACTS, RECEIVED_CONTACTS, RECEIVED_SERVER_ERRORS, SAVE_CONTACTS, SAVED_CONTACTS } from './constants';

import { createAction } from 'redux-actions';

export const receivedServerErrors = createAction(RECEIVED_SERVER_ERRORS);
export const getContacts = createAction(GET_CONTACTS);
export const receivedContacts = createAction(RECEIVED_CONTACTS);
export const saveContacts = (formId: string) =>
    createAction(SAVE_CONTACTS, ({ contacts }) => {
        return {
            formId,
            contacts
        };
    });
export const savedContacts = createAction(SAVED_CONTACTS);



// WEBPACK FOOTER //
// ./src/core/state/text-control/actions.js